import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {OverviewAgentTabNamesEnum, toAgentId} from '../../../../types'
import type {ThinNestedEntryPointParamsObject} from '../../../../types/entryPoints'
import {makeResource} from '../../../../utils/makeResource'
import {queryToObject} from '../../../../utils/queryParams'
import {getAgentsPagesQueries, poolsAuthorizePermissionsQuery} from '../AgentsPages.queries'
import {licensingDataQuery} from '../components/AgentListView/AuthorizeAgent/AuthorizeAgent.queries'

import type {AgentPageContainerComponent, EntryPoints} from './AgentPage.container'
import {AgentParametersEntryPoint} from './AgentParameters/AgentParameters.entryPoint'

export const AgentPageEntryPoint: EntryPoint<AgentPageContainerComponent, LoaderFunctionArgs> = {
  root: makeResource(
    'AgentPage',
    () => import(/* webpackChunkName: "AgentPage" */ './AgentPage.container'),
  ),
  getPreloadProps: ({params, request}) => {
    const entryPoints: ThinNestedEntryPointParamsObject<EntryPoints> = {}
    const url = new URL(request.url)
    const {tab} = queryToObject(url.search)
    if (tab === OverviewAgentTabNamesEnum.PARAMETERS) {
      entryPoints.parametersTab = {
        entryPoint: AgentParametersEntryPoint,
        entryPointParams: toAgentId(params.agentId!),
      }
    }
    return {
      queries: {
        ...getAgentsPagesQueries(),
        licensingData: {
          parameters: getRequest(licensingDataQuery),
          variables: {},
        },
        poolsAuthorizePermission: {
          parameters: getRequest(poolsAuthorizePermissionsQuery),
          variables: {},
        },
      },
      entryPoints,
    }
  },
}
